export default __webpack_public_path__ + "static/media/staking-background-2.cdf56568.png";